import EnumObject from '@/domain/enum-object.entity';
import RuleScriptParameter from './rule-script-parameter.entity';

export default class RuleHistoryDetail {
  id: string;

  ruleId: string;

  version: string;

  versionMajor: number;

  versionMinor: number;

  status: EnumObject;

  createdBy: string;

  createdDate: string;

  name: string;

  description: string;

  type: string;

  script: string;

  ruleType: string;

  parameters: RuleScriptParameter[];

  dataSourceId: string | null;

  constructor(obj: any = {}) {
    const snapshot = obj.snapshot || {};

    this.id = obj.id || '';
    this.ruleId = obj.ruleId || '';
    this.version = obj.version || '';
    this.versionMajor = obj.versionMajor || 0;
    this.versionMinor = obj.versionMinor || 0;
    this.status = EnumObject.of(obj.status);
    this.createdBy = obj.createdBy || '';
    this.createdDate = obj.createdDate || '';
    this.name = snapshot.name || '';
    this.description = snapshot.description || '';
    this.type = snapshot.type || '';
    this.script = snapshot.script || '';
    this.ruleType = snapshot.ruleType || '';
    this.parameters = snapshot.parameters ? RuleScriptParameter.ofList(snapshot.parameters) : [];
    this.dataSourceId = snapshot.dataSourceId || null;
  }

  public static of(obj: any = {}): RuleHistoryDetail {
    return new RuleHistoryDetail(obj);
  }
}
